export const NAVBAR_MENU_LIST_DEFAULTS_V2 = {
  padding: '16px',
  margin: '0px',
  gap: '16px',
  background: 'transparent',
  justify: 'start',
  height: 'fit-content',
  width: '100%',
  contentWidth: '100%',
};
